import { ITaxonomyCutomerState, ITaxonomyState } from './store';
import { TaxonomyActionTypes, TaxonomyActionTypeNames } from './actionTypes';
import {
  TaxonomyAssetInfoAdmin,
  TaxonomyCustomerAdmin,
  TaxonomyCustomerBrand,
  WindTaxonomy,
} from './types';

export const initialTaxonomyState: ITaxonomyState = {
  taxonomy: undefined,
  fetchStatus: undefined,
};

export function taxonomyReducer(
  state = initialTaxonomyState,
  action: TaxonomyActionTypes
): ITaxonomyState {
  switch (action.type) {
    case TaxonomyActionTypeNames.FETCH_ALL_SUCCESS:
      return {
        ...state,
        taxonomy: action.taxonomy,
        fetchStatus: '200',
      };
    case TaxonomyActionTypeNames.FETCH_ALL_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };
    case TaxonomyActionTypeNames.DELETE_TURBINE_BY_ID_SUCCESS:
      const listWindfarms: WindTaxonomy[] = JSON.parse(
        JSON.stringify(state.taxonomy)
      );
      const turbineDeleted = action.sectionSystemKey;

      listWindfarms.forEach((windfarm) => {
        const indexTurbineDeleted = windfarm.taxonomyCustomer.taxonomySystemInfos.findIndex(
          (x) => x.sectionSystemKey === turbineDeleted
        );
        if (indexTurbineDeleted != -1)
          windfarm?.taxonomyCustomer.taxonomySystemInfos.splice(
            indexTurbineDeleted!,
            1
          );
      });

      return {
        ...state,
        taxonomy: listWindfarms,
        fetchStatus: '200',
      };
    case TaxonomyActionTypeNames.DELETE_WINDFARM_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };
    case TaxonomyActionTypeNames.DELETE_TURBINE_SUCCESS:
      return {
        ...state,
        taxonomy: undefined,
        fetchStatus: '200',
      };
    case TaxonomyActionTypeNames.DELETE_TURBINE_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };

    case TaxonomyActionTypeNames.ADD_TAXONOMY_SUCCESS:
      let currentTaxonomy: WindTaxonomy[] = [];

      const newWindfarms: TaxonomyCustomerAdmin[] = JSON.parse(
        JSON.stringify(action.taxonomyCustomer)
      );

      if (typeof state.taxonomy !== 'undefined')
        currentTaxonomy = JSON.parse(JSON.stringify(state.taxonomy));

      newWindfarms.forEach((windfarm) => {
        let windTaxonomy: WindTaxonomy = {
          taxonomyCustomerEditedInWeb: false,
          taxonomySystemInfoIsEditedInWeb: false,
          taxonomyCustomer: windfarm,
          taxonomyCustomerUpdateTimeWeb: new Date(),
          taxonomySystemInfoUpdateTimeWeb: new Date(),
        };
        currentTaxonomy?.push(windTaxonomy);
      });

      return {
        ...state,
        taxonomy: currentTaxonomy,
        fetchStatus: '200',
      };
    case TaxonomyActionTypeNames.ADD_TAXONOMY_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };

    case TaxonomyActionTypeNames.UPDATE_TAXONOMY_SUCCESS:
      let allTaxonomy: WindTaxonomy[] = [];

      const editedWindfarms: TaxonomyCustomerAdmin[] = JSON.parse(
        JSON.stringify(action.taxonomyCustomer)
      );

      if (typeof state.taxonomy !== 'undefined')
        allTaxonomy = JSON.parse(JSON.stringify(state.taxonomy));

      editedWindfarms.forEach((windfarm) => {
        const windfarmIndex = allTaxonomy.findIndex(
          (x) => x.taxonomyCustomer.plantUnitKey === windfarm.plantUnitKey
        );
        if (windfarmIndex != -1) {
          allTaxonomy[windfarmIndex].taxonomyCustomer.companyId =
            windfarm.companyId;
          allTaxonomy[windfarmIndex].taxonomyCustomer.companyName =
            windfarm.companyName;
          allTaxonomy[windfarmIndex].taxonomyCustomer.siteCountryCode =
            windfarm.siteCountryCode;
          allTaxonomy[windfarmIndex].taxonomyCustomer.siteCountryDescription =
            windfarm.siteCountryDescription;
          allTaxonomy[windfarmIndex].taxonomyCustomer.siteAreaDescription =
            windfarm.siteAreaDescription;
          allTaxonomy[windfarmIndex].taxonomyCustomer.plantUnitId =
            windfarm.plantUnitId;
          allTaxonomy[windfarmIndex].taxonomyCustomer.plantUnitDescription =
            windfarm.plantUnitDescription;
          allTaxonomy[windfarmIndex].taxonomyCustomer.plantUnitCapacity =
            windfarm.plantUnitCapacity;
          allTaxonomy[
            windfarmIndex
          ].taxonomyCustomer.plantUnitContributionMargin =
            windfarm.plantUnitContributionMargin;
        }
      });

      return {
        ...state,
        taxonomy: allTaxonomy,
        fetchStatus: '200',
      };
    case TaxonomyActionTypeNames.GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        taxonomyCountryCustomer: action.taxonomyCountryCustomer,
        fetchStatus: '200',
      };
    case TaxonomyActionTypeNames.GET_COUNTRIES_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };

    case TaxonomyActionTypeNames.MODIFY_WINDFARM_SUCCESS:
      return {
        ...state,
        taxonomy: undefined,
        fetchStatus: '200',
      };
    case TaxonomyActionTypeNames.MODIFY_WINDFARM_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };
    case TaxonomyActionTypeNames.FETCH_BRAND_TAXONOMY_CUSTOMER_SUCCES:
      return {
        ...state,
        taxonomyBrand: action.taxonomyBrand,
        fetchStatus: '200',
      };
    case TaxonomyActionTypeNames.FETCH_BRAND_TAXONOMY_CUSTOMER_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };
    case TaxonomyActionTypeNames.GET_OPERATIONS_SUCCESS:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
        taxonomyOperations: action.taxonomyOperations,
      };

    case TaxonomyActionTypeNames.GET_OPERATIONS_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };
    case TaxonomyActionTypeNames.FETCH_ASSETS_SUCCESS:
      return {
        ...state,
        taxonomyAssets: action.taxonomyAssets,
      };
    case TaxonomyActionTypeNames.FETCH_ASSETS_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };
    case TaxonomyActionTypeNames.GET_ASSETS_MANUFACTURER_MODELS_SUCCESS:
      return {
        ...state,
        taxonomyAssetManufacturer: action.taxonomyAssetsManufacturerModel,
      };
    case TaxonomyActionTypeNames.GET_ASSETS_MANUFACTURER_MODELS_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };

    case TaxonomyActionTypeNames.POST_NEW_ASSET_SUCCESS:
      let listAssets: TaxonomyAssetInfoAdmin[] = [];

      const newAssets: TaxonomyAssetInfoAdmin[] = JSON.parse(
        JSON.stringify(action.taxonomyAddAssetInfo)
      );

      if (typeof state.taxonomyAssets !== 'undefined') {
        listAssets = JSON.parse(JSON.stringify(state.taxonomyAssets));
      }

      newAssets.forEach((newAsset) => {
        if (
          listAssets.findIndex(
            (x) => x.sectionSystemKey === newAsset.sectionSystemKey
          ) != -1 ||
          newAsset.sectionSystemId === action.turbineSelected
        ) {
          listAssets.push(newAsset);
        }
      });

      return {
        ...state,
        taxonomyAssets: listAssets,
      };

    case TaxonomyActionTypeNames.POST_NEW_ASSET_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };
    case TaxonomyActionTypeNames.PUT_ASSET_SUCCESS:
      const listTaxonomyAddAssets = state.taxonomyAssets;
      const modifiedTaxonomy = action.taxonomyAddAssetInfo;

      const asset = listTaxonomyAddAssets?.find(
        (x) => x.assetKey === modifiedTaxonomy.assetKey
      );

      asset!.manufacturerModel = modifiedTaxonomy.manufacturerModel;
      asset!.manufacturerName = modifiedTaxonomy.manufacturerName;
      asset!.manufacturerSerialNumber =
        modifiedTaxonomy.manufacturerSerialNumber;
      asset!.costReplacement = modifiedTaxonomy.costReplacement;
      asset!.purchaseCondition = modifiedTaxonomy.purchaseCondition;
      asset!.equioAttributes = modifiedTaxonomy.equipAttributes;
      asset!.assetInstalledDate = modifiedTaxonomy.assetInstalledDate;

      return {
        ...state,
        taxonomyAddAssetInfo: undefined,
      };
    case TaxonomyActionTypeNames.PUT_ASSET_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };
    case TaxonomyActionTypeNames.DELETE_ASSET_SUCCESS:
      const assetsKey = action.assetKey;
      const listAssetsToDelete = state.taxonomyAssets;

      assetsKey.forEach((assetKey) => {
        const assetIndex = listAssetsToDelete?.findIndex(
          (x) => x.assetKey === assetKey.assetKey
        );
        if (assetIndex != -1) listAssetsToDelete?.splice(assetIndex!, 1);
      });

      return {
        ...state,
        fetchStatus: action.fetchStatus,
        taxonomyAssets: listAssetsToDelete,
      };
    case TaxonomyActionTypeNames.GET_BEARING_POSITIONS_SUCCESS:
      return {
        ...state,
        bearingPositions: action.bearingPositions,
      };
    case TaxonomyActionTypeNames.GET_BEARING_POSITIONS_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };
    case TaxonomyActionTypeNames.GET_BEARING_SUCCESS:
      return {
        ...state,
        bearings: action.taxonomyAssets,
      };
    case TaxonomyActionTypeNames.POST_BEARINGS_SUCCESS:
      const taxonomyAssets = JSON.parse(JSON.stringify(state.taxonomyAssets));
      const newBearings = action.taxonomyAddAssetInfo;

      newBearings.forEach((newBearing) => {
        taxonomyAssets
          ?.find((x) => x.plantUnitKey === newBearing.plantUnitKey)
          ?.taxonomiesPart.push(newBearing);
      });
      return {
        ...state,
        taxonomyAssets: taxonomyAssets,
      };
    case TaxonomyActionTypeNames.POST_BEARINGS_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };
    case TaxonomyActionTypeNames.PUT_BEARINGS_SUCCESS:
      const listBearings = JSON.parse(JSON.stringify(state.taxonomyAssets));
      const editedBearing = action.taxonomyAddAssetInfo;

      const indexBearing = listBearings?.findIndex(
        (x) => x.assetKey === editedBearing.assetKey
      );

      if (indexBearing != -1) {
        const bearing = listBearings[indexBearing].taxonomiesPart.find(
          (x) => x.assetPartKey === editedBearing.assetPartKey
        );

        if (bearing != null) {
          bearing.partId = editedBearing.partId;
          bearing.partName = editedBearing.partName;
          bearing.partManufacturer = editedBearing.partManufacturer;
          bearing.oemPartCode = editedBearing.oemPartCode;
          bearing.oemPartDescription = editedBearing.oemPartDescription;
          bearing.customerPartCode = editedBearing.customerPartCode;
          bearing.customerPartDescription =
            editedBearing.customerPartDescription;
          bearing.competitorProductIdentification =
            editedBearing.competitorProductIdentification;
          bearing.skfProductGroup = editedBearing.skfProductGroup;
          bearing.skfPartCode = editedBearing.skfPartCode;
          bearing.installedDate = editedBearing.installedDate;
        }
      }

      return {
        ...state,
        taxonomyAssets: listBearings,
      };
    case TaxonomyActionTypeNames.PUT_BEARINGS_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };
    case TaxonomyActionTypeNames.DELETE_BEARING_SUCCESS:
      const bearings: TaxonomyAssetInfoAdmin[] = JSON.parse(
        JSON.stringify(state.taxonomyAssets)
      );
      const bearingToDelelte = action.assetPartKey;

      bearings.forEach((bearing) => {
        const baeringToDeleteIndex = bearing.taxonomiesPart.findIndex(
          (x) => x.assetPartKey === bearingToDelelte
        );
        if (baeringToDeleteIndex != -1)
          bearing.taxonomiesPart.splice(baeringToDeleteIndex, 1);
      });

      return {
        ...state,
        fetchStatus: action.fetchStatus,
        taxonomyAssets: bearings,
      };
    case TaxonomyActionTypeNames.PUT_TURBINE_SUCCESS:
      const taxonomy = JSON.parse(JSON.stringify(state.taxonomy));
      const taxonomyBrand: TaxonomyCustomerBrand[] = JSON.parse(
        JSON.stringify(state.taxonomyBrand)
      );
      let indexTurbine = 0;
      const newTurbine = action.taxonomy;
      let taxonomySystemInfo;

      newTurbine.forEach((turbine) => {
        indexTurbine = taxonomy?.findIndex(
          (x) => x.taxonomyCustomer.plantUnitKey === turbine.plantUnitKey
        );
      });

      if (indexTurbine != -1) {
        taxonomySystemInfo = taxonomy[
          indexTurbine
        ].taxonomyCustomer.taxonomySystemInfos.find(
          (y) => y.sectionSystemKey === action.taxonomy[0]?.sectionSystemKey
        );

        taxonomySystemInfo.sectionSystemId = newTurbine[0].sectionSystemId;
        taxonomySystemInfo.sectionSystemKey = newTurbine[0].sectionSystemKey;
        taxonomySystemInfo.systemBrand = newTurbine[0].systemBrand;
        taxonomySystemInfo.systemModel = newTurbine[0].systemModel;
        taxonomySystemInfo.sectionSystemCapacity =
          newTurbine[0].sectionSystemCapacity;
        taxonomySystemInfo.sectionSystemContributionMargin =
          newTurbine[0].sectionSystemContributionMargin;
        taxonomySystemInfo.latitude = newTurbine[0].latitude;
        taxonomySystemInfo.longitude = newTurbine[0].longitude;
        taxonomySystemInfo.commissioningDate = newTurbine[0].commissioningDate;
        taxonomyBrand.push({
          systemBrand: newTurbine[0].systemBrand,
          systemModel: newTurbine[0].systemModel,
        });
      }

      return {
        ...state,
        fetchStatus: action.fetchStatus,
        taxonomy: taxonomy,
        taxonomyBrand: taxonomyBrand,
      };

    case TaxonomyActionTypeNames.FETCH_INDUSTRY_TAXONOMY_CUSTOMER_POST_SUCCESS:
      const newTurbines: WindTaxonomy[] = JSON.parse(
        JSON.stringify(state.taxonomy)
      );
      const newTaxonomyBrand: TaxonomyCustomerBrand[] = [];
      action.taxonomy.forEach((newTurbine) => {
        let windfarmIndex = newTurbines?.findIndex(
          (x) => x.taxonomyCustomer.plantUnitKey === newTurbine.plantUnitKey
        );
        if (windfarmIndex != -1)
          newTurbines[windfarmIndex].taxonomyCustomer.taxonomySystemInfos.push(
            newTurbine
          );
        newTaxonomyBrand.push({
          systemBrand: newTurbine.systemBrand,
          systemModel: newTurbine.systemModel,
        });
      });

      return {
        ...state,
        fetchStatus: action.fetchStatus,
        taxonomy: newTurbines,
        taxonomyBrand: newTaxonomyBrand,
      };
    case TaxonomyActionTypeNames.GET_UPLOAD_TAXONOMY_SUCCESS:
      return {
        ...state,
        taxonomyUpload: action.taxonomyUpload,
      };
    case TaxonomyActionTypeNames.GET_UPLOAD_TAXONOMY_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };
    default:
      return state;
  }
}

export function taxonomyCustomerReducer(
  state = initialTaxonomyState,
  action: TaxonomyActionTypes
): ITaxonomyCutomerState {
  switch (action.type) {
    case TaxonomyActionTypeNames.FETCH_INDUSTRY_TAXONOMY_CUSTOMER_SUCCES:
      return {
        ...state,
        taxonomyCustomer: action.taxonomyCustomer,
        fetchStatus: '200',
      };
    case TaxonomyActionTypeNames.FETCH_INDUSTRY_TAXONOMY_CUSTOMER_ERROR:
      return {
        ...state,
        fetchStatus: action.fetchStatus,
      };

    default:
      return state;
  }
}
